module.exports = __webpack_public_path__ + "fonts/Young-Italic.5256d160.woff";